// ChartDonutTransaction.jsx
import { getTransactionByAccountType } from "../../service/api/TransactionService";
import { useChartLoading } from "../../service/Hooks/useChartLoading";
import useSelectedDomain from "../../service/Hooks/useSelectedDomain";
import ChartSkeleton from "../../skeleton/ChartSkeleton";
import DonutChart from "../DonutChart/DonutChart";

export const ChartDonutTransaction = ({ selectedYear = null }) => {
  const selectedDomain = useSelectedDomain();
  
  const { loading } = useChartLoading(
    () => getTransactionByAccountType(selectedDomain?.id, selectedYear),
    [selectedDomain?.id, selectedYear]
  );

  if (loading) {
    return <ChartSkeleton delay="0.9s" />;
  }
  
  return (
    <DonutChart
      title="Transactions en bourse"
      subtitle="Répartition par catégorie"
      fetchData={() => getTransactionByAccountType(selectedDomain.id, selectedYear)}
      valueKey="transactionCount"
      formatValue={(v) => v.toLocaleString('fr-FR')}
      centerLabel="Transactions"
      selectedYear={selectedYear}
      delay="0.9s"
    />
  );
};